<template>
  <div>
    <div class="bold fs22 pdBtm20 mrBtm20 borBtmdd">邀请新学员减免报名费</div>
    <div class="difcc">
      <div class="link difcac">{{url}}</div>
      <div class="copy" @click="copyLink()">复制邀请链接</div>
      <!--奖励说明-->
      <div class="explain">
        <div class="bold fs18">奖励说明</div>
        <div v-html="shuoming" class="mrTop10">
          <!--<p class="fs18 col101010 mrTop10" v-for="(item,index) in 5" :key="index">{{index+1}}：这是奖励说明这是奖励说明这是奖励说明这是奖励说明</p>-->

        </div>
      </div>
    </div>
    <!--已邀请-->
    <div class="bold fs22 pdBtm20 mrBtm20 borBtmdd" style="margin-top: 5rem;">已邀请</div>
    <div class="dif difw" v-if="list.length>0">
      <div class="item difcc" v-for="(item,index) in list" :key="index">
        <img class="bra bgcb" :src="$store.state.url+item.image" style="width: 6rem;height: 6rem;">
        <div class="fs14 col101010 mrTop10 one_overflow">{{ item.name }}</div>
      </div>
    </div>
    <div style="text-align: center;margin-top: 5rem;" v-else>
      <div class="fs14 col101010 mrTop10 one_overflow">暂无已邀请</div>
    </div>
  </div>
</template>

<script>
export default {
  name: "invitation",
  data() {
    return {
      url: '',
      list: [],
      shuoming: '',//奖励说明
    }
  },
  methods: {
    getSystem() {
      this.$axios("POST","/index/cms_system",{})
      .then(res => {
        if(res.code===1) this.shuoming = res.data.guige
      })
    },
    getList() { //获取已邀请列表
      this.$axios("POST","/user/invite",{})
      .then(res => {
        if(res.code===1) {
          this.list = res.data.list
        }
      })
    },
    getUrl() { //获取邀请链接
      let p = window.location.protocol;
      let h = window.location.host;
      let uid = JSON.parse(localStorage.getItem('jiaoyu')).id
      let href = p+'//'+h+'/#/?pid='+uid
      this.url = href
      console.log(href);
    },
    copyLink() { // 复制链接
      //调用copy函数
      this.copy(this.url);
    },
    copy(data) {
      // 存储传递过来的数据
      let link = data;
      // 创建一个input 元素
      // createElement() 方法通过指定名称创建一个元素
      let newInput = document.createElement("input");
      // 讲存储的数据赋值给input的value值
      newInput.value = link;
      // appendChild() 方法向节点添加最后一个子节点。
      document.body.appendChild(newInput);
      // 选中input元素中的文本
      // select() 方法用于选择该元素中的文本。
      newInput.select();
      // 执行浏览器复制命令
      //  execCommand方法是执行一个对当前文档，当前选择或者给出范围的命令
      document.execCommand("Copy");
      // 清空输入框
      newInput.remove();
      // 下面是element的弹窗 不需要的自行删除就好
      this.$message({
        message: "复制成功",
        type: "success",
      });
    },
  },
  created() {
    this.getUrl()
    this.getSystem()
    this.getList()
  }
}
</script>
c
<style scoped>
  .link{
    border: 2px solid #bbb;
    width: 90%;
    height: 7rem;
    border-radius: 5px;
    font-size: 2rem;
    color: #101010;
  }
  .copy{
    color: #e24537;
    font-size: 2rem;
    margin-top: 3rem;
    margin-bottom: 3rem;
    font-weight: bold;
    cursor: pointer;
  }
  .explain{
    background: #FAFAFA;
    box-sizing: border-box;
    padding: 2rem 3rem;
    width: 90%;
  }
  .item{
    width: 6rem;
    margin-right: 2rem;
    margin-bottom: 2rem;
  }
</style>